import { type ReactElement } from 'react';
import PageShell, { PageSection } from '../components/PageShell';

export default function Api(): ReactElement {
  return (
    <PageShell
      title="API-Schnittstelle"
      intro="Was eine API ist – und wie sie Saldify mit Ihren anderen Programmen verbindet."
    >
      <PageSection title="Was ist eine API?">
        <p>
          Eine API (englisch für „Programmierschnittstelle") ist eine technische
          Brücke zwischen zwei Programmen. Sie ermöglicht es, dass Software direkt und
          automatisch Daten austauscht – ohne dass jemand etwas von Hand abtippen oder
          per Datei hin- und herschieben muss. Vereinfacht gesagt: Die API ist die
          Sprache, über die andere Programme „mit Saldify reden" können.
        </p>
      </PageSection>

      <PageSection title="Wofür ist das nützlich?">
        <p>
          Über eine Schnittstelle lassen sich wiederkehrende Aufgaben automatisieren
          und Saldify in bestehende Abläufe einbinden, zum Beispiel:
        </p>
        <ul className="list-disc pl-6 mt-3 space-y-1">
          <li>
            Rechnungen automatisch aus einem Online-Shop oder anderen System in
            Saldify anlegen
          </li>
          <li>Belege und Umsätze programmgesteuert übertragen</li>
          <li>Auswertungen oder Daten an eigene Tools und Dashboards weitergeben</li>
          <li>
            Saldify mit Anwendungen verbinden, die Sie ohnehin schon im Alltag nutzen
          </li>
        </ul>
      </PageSection>

      <PageSection title="Status & Zugang">
        <p>
          Unsere öffentliche API befindet sich in Entwicklung. Schon heute lässt sich
          Saldify über zahlreiche{' '}
          <a href="/funktionen/integrationen" className="text-primary-600 hover:underline">
            Integrationen
          </a>{' '}
          mit anderen Diensten verbinden. Wenn Sie Saldify programmatisch anbinden
          möchten oder einen konkreten Anwendungsfall haben, schreiben Sie uns an{' '}
          <a href="mailto:info@saldify.de" className="text-primary-600 hover:underline">
            info@saldify.de
          </a>{' '}
          – wir melden uns mit den nächsten Schritten.
        </p>
      </PageSection>
    </PageShell>
  );
}
